var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "screen",
      style: { backgroundColor: _vm.theme.screenBackgroundColor.value },
    },
    [
      _c(
        "header",
        {
          staticClass: "header",
          style: { backgroundColor: _vm.theme.headerBackgroundColor.value },
        },
        [
          _c(
            "h1",
            {
              staticClass: "title",
              style: { color: _vm.theme.headerTextColor.value },
            },
            [_vm._v(_vm._s(this.$props.venue.venue_name))]
          ),
        ]
      ),
      _vm.venue.picture
        ? _c("div", { staticClass: "logo-container" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.venue.picture, alt: "Venue Logo" },
            }),
          ])
        : _vm._e(),
      _vm._l(_vm.bars, function (bar, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "tile",
            style: { backgroundColor: _vm.theme.tileBackgroundColor.value },
          },
          [
            _c(
              "h2",
              {
                staticClass: "tile-title",
                style: { color: _vm.theme.PrimaryTextColor.value },
              },
              [_vm._v(_vm._s(bar.name))]
            ),
            _c(
              "p",
              {
                staticClass: "tile-description",
                style: { color: _vm.theme.SecondaryTextColor.value },
              },
              [_vm._v(_vm._s(bar.description))]
            ),
            _c(
              "p",
              {
                staticClass: "tile-time",
                style: { color: _vm.theme.SecondaryTextColor.value },
              },
              [_vm._v(_vm._s(bar.wait))]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }